import axios, { AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios'
import { IResponseData } from '@/types'
import { diffTokenTime, getTokenTime, getToken, setToken, setTokenExpireTime, getRefreshTokenCode, getLoginType } from '@/utils/auth'
import { refreshToken } from '@/api/loginApi'
import {
    ElMessage

} from 'element-plus'
import store from '@/store'
import router from '@/router'
type TAxiosOption = {
    baseURL: string
    timeout: number
}

const config = {
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 120000
}

async function refreshTokenInfo() {
    // 设置请求参数
    const params = {
        token: getToken(),
        code: getRefreshTokenCode(),
        logintype: getLoginType(),
        state: '1234'
    }
    return await refreshToken(params)
}
// 定义变量 表示是否刷新token
let isRefresh = false
class Http {
    // service: AxiosInstance;
    service;
    constructor(config: TAxiosOption) {
        this.service = axios.create(config)
        // 请求拦截  this.service.interceptors.request.use(config => config, error => Promise.reject(error))*/
        this.service.interceptors.request.use(async (config: AxiosRequestConfig) => {
            console.log('请求配置:', config) // 打印请求配置，检查URL和headers
            // 获取当前系统时间
            const currentTime = new Date().getTime()
            // 获取token过期时间
            const expireTime = Number(getTokenTime())
            if (expireTime > 0) {
                // 计算时间
                const min = (expireTime - currentTime) / 60000
                // console.log(min + '==!!token离过期时间相差')
                // 如果token离过期时间相差10分钟 则刷新token
                if (min < 10) {
                    //  console.log(min + '==token离过期时间相差')
                    // 判断是否刷新
                    if (!isRefresh) {
                        // 标识刷新
                        isRefresh = true
                        try {
                            const res: any = await refreshTokenInfo()
                            console.log('刷新TOKEN')
                            console.log(res)
                            if (res.code === 500 && res.success === false) {
                                localStorage.clear()
                                router.replace('/login')
                            } else {
                                console.log(res)
                                setToken(res.data.token)
                                store.commit('login/setUAccessToken', res.data.uaccessToken)
                                store.commit('login/setURefreshToken', res.data.urefreshToken)
                                store.commit('login/setUExpireTime', res.data.uexpireTime)
                                setTokenExpireTime(res.data.expireTime);

                                (config.headers as AxiosRequestHeaders).token = localStorage.getItem('token')
                                return config
                            }
                        } catch (error) {
                            console.log(error)
                        } finally {
                            // 修改是否刷新token的状态
                            isRefresh = false
                        }
                    } else {
                        console.log('444')
                    }
                }
            }
            (config.headers as AxiosRequestHeaders).token = localStorage.getItem('token')
            return config
        }, (error) => {
            /* 请求错误
            1. 关闭全屏loading动画
            2. 重定向到错误页
            */
            return Promise.reject(error) // 为了可以在代码中catch到错误信息
        })
        // 响应拦截   this.service.interceptors.response.use(response => response.data, error => Promise.reject(error))*/
        this.service.interceptors.response.use((response: AxiosResponse<any>) => {
            // const { data, meta } = response.data
            // if (meta.status === 200 || meta.status === 201) {
            //     return data
            // } else {
            //     ElMessage.error(meta.msg)
            //     return Promise.reject(new Error(meta.msg))
            // }
            // const data = response.data
            /*
            1. 关闭全屏loading动画
            2. 数据解密
            3. 根据 response.data.code 做不同的错误处理
            4. ……
            */
            return response.data
        }, error => {
            ElMessage.error('请求失败,请联系管理员！')
            console.log(error)
            return Promise.reject(error)
        })
    }

    get<T>(url: string, params?: object, _object = {}): Promise<IResponseData<T>> {
        return this.service.get(url, { params, ..._object })
    }

    post<T>(url: string, params?: object, _object = {}): Promise<T> {
        return this.service.post(url, params, _object)
    }

    put<T>(url: string, params?: object, _object = {}): Promise<T> {
        return this.service.put(url, params, _object)
    }

    delete<T>(url: string, params?: any, _object = {}): Promise<T> {
        return this.service.delete(url, { params, ..._object })
    }
}

export default new Http(config)
